import React, { useContext, useState } from 'react'
import { Uploading } from '../../../components/importers/helperComponents'
import { useParams } from 'react-router-dom'
import { postRequest } from '../../../services/base'
import { NavContext } from '../../../context/global_context'

const UploadSvgImage = ({
  id,
  svgImageFilename,
  svgDisplayName,
  getPowerDistributions,
}) => {
  let { vehicle } = useParams()
  const [value, dispatch] = useContext(NavContext)

  const [uploadingState, setUploadingState] = useState(false)
  const [filename, setFilename] = useState(null)

  const uploadFile = async (e) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Uploading SVG file',
        showLoader: true,
      },
      notification: {},
    })
    let formData = new FormData()
    setUploadingState(true)
    formData.append('svg', e.target.files[0])
    let res = await postRequest(
      `/api/power_distributions/upload_svg/${vehicle}/${id}/`,
      formData
    )
    dispatch({
      type: 'notification',
      data: {
        notification_type: res.status ? 'suceess' : 'error',
        msg: res.msg,
      },
    })
    setUploadingState(false)
    setTimeout(() => {
      getPowerDistributions()
    }, 5000)
  }

  const displayFilename = filename || svgImageFilename

  return (
    <>
      <div className="w-1/6 px-2 break-all">
        {uploadingState && <Uploading />}
        {displayFilename ? (
          <label
            htmlFor={`svg_${id}`}
            className="inline-block text-blue-900 font-medium"
          >
            {svgDisplayName}
          </label>
        ) : (
          <form>
            <label
              htmlFor={`svg_${id}`}
              className={`cursor-pointer inline-block text-blue-500 underline ${uploadingState && 'hidden'}`}
            >
              Upload SVG image
            </label>
            <input
              type="file"
              name={`svg_${id}`}
              id={`svg_${id}`}
              onClick={(e) => (e.target.value = null)}
              onChange={uploadFile}
              style={{ position: 'absolute', opacity: 0, zIndex: -1 }}
            />
          </form>
        )}
      </div>
    </>
  )
}

export default UploadSvgImage
